export const shouldLoadAttachment = (extension) => {
    const allowedExtensions = process.env.REACT_APP_SUPPORTED_THUMBNAIL_EXTENSIONS
    const extensionsArray = allowedExtensions.split(',')
    return extensionsArray.indexOf(extension.toLowerCase()) > -1
}